module.exports = __webpack_public_path__ + "static/img/about042.fa45001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about042.png
// module id = YIfv
// module chunks = 1